// src/pages/WorldHeritagePage.jsx
import React from "react";
import SiteHeader from "../components/SiteHeader";
import Footer from "../components/Footer";

export default function WorldHeritagePage() {
  return (
    <div className="flex flex-col min-h-screen bg-[#fffaf2]">
      {/* ส่วนหัว */}
      <SiteHeader />

      {/* ส่วนเนื้อหาตรงกลาง */}
      <main className="flex-1 flex flex-col items-center justify-center p-6">
        <div className="text-center bg-white/60 p-10 rounded-2xl shadow-sm border border-black/5">
          <h1 className="text-2xl md:text-4xl font-bold text-[#5b4a3e] mb-4">
            มรดกโลกเชียงใหม่
          </h1>
          <p className="text-lg md:text-xl text-[#d8653b] font-medium animate-pulse">
            กำลังเตรียมใส่ Content...
          </p>
        </div>
      </main>

      {/* ส่วนท้าย */}
      <Footer />
    </div>
  );
}